module.exports = __webpack_public_path__ + "img/riceball_half.88b6e15e.svg";